// Locale-aware currency formatting.
// IT: 1.234.567,89   EN: 1,234,567.89
function localeFor(lang) {
  return lang === "it" ? "it-IT" : "en-US";
}

const MONTHS_SHORT_IT = ["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"];
const MONTHS_SHORT_EN = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

export function fmtMonthLabel(row, lang = "en") {
  if (!row || !row.year || !row.month) return "";
  const arr = lang === "it" ? MONTHS_SHORT_IT : MONTHS_SHORT_EN;
  return `${arr[row.month - 1]} ${row.year}`;
}

export function fmtUSD(v, lang = "en") {
  if (v === null || v === undefined || isNaN(v)) {
    return lang === "it" ? "0 $" : "$0";
  }
  const sign = v < 0 ? "-" : "";
  const n = Math.abs(v);
  const num = n.toLocaleString(localeFor(lang), {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    useGrouping: "always",
  });
  return lang === "it" ? `${sign}${num} $` : `${sign}$${num}`;
}

export function fmtUSDPrecise(v, lang = "en") {
  if (v === null || v === undefined || isNaN(v)) {
    return lang === "it" ? "0,00 $" : "$0.00";
  }
  const sign = v < 0 ? "-" : "";
  const n = Math.abs(v);
  const num = n.toLocaleString(localeFor(lang), {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    useGrouping: "always",
  });
  return lang === "it" ? `${sign}${num} $` : `${sign}$${num}`;
}

// Short "k" format for chart Y-axis.
export function fmtShort(v, lang = "en") {
  if (v === null || v === undefined || isNaN(v)) return "0";
  const abs = Math.abs(v);
  if (abs >= 1000) {
    const val = v / 1000;
    const s = val.toLocaleString(localeFor(lang), {
      maximumFractionDigits: 0,
      useGrouping: "always",
    });
    return `${s}k`;
  }
  return v.toLocaleString(localeFor(lang), { maximumFractionDigits: 0 });
}
